import { Tooltip } from '@mui/material'

/**
 * TerraPlanner custom tooltip with consistent styling for dark/light modes
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - Element that triggers the tooltip
 * @param {React.ReactNode} props.title - Tooltip content
 * @param {boolean} [props.followCursor=false] - Whether tooltip follows cursor
 * @param {boolean} [props.arrow=true] - Show arrow pointing to element
 * @param {number} [props.minWidth=200] - Minimum tooltip width in pixels
 * @param {number} [props.maxWidth=500] - Maximum tooltip width in pixels
 * @param {number} [props.enterTouchDelay=0] - Touch delay before showing
 * @param {number} [props.leaveTouchDelay=500] - Touch delay before hiding
 * @param {number} [props.leaveDelay=500] - Mouse delay before hiding
 */
export const TpTooltip = ({
  children,
  title,
  followCursor = true,
  arrow = false,
  enterTouchDelay = 0,
  leaveTouchDelay = 0,
  leaveDelay = 0,
  minWidth = 50,
  maxWidth = 400,
  slotProps,
  ...props
}) => {
  // Base styling for all TpTooltips
  const baseSlotProps = {
    popper: {
      sx: {
        '& .MuiTooltip-tooltip': {
          bgcolor: 'background.paper',
          color: 'text.primary',
          boxShadow: 1,
          minWidth: minWidth,
          maxWidth: maxWidth,
          fontStyle: 'italic',

          '& .MuiTypography-root': {
            fontSize: '0.75rem',
            fontStyle: 'italic',
            color: 'text.secondary',
          }
        }
      }
    },
  }

  // Merge custom slotProps with base (allows adding modifiers, etc.)
  const mergedSlotProps = slotProps ? {
    popper: {
      ...baseSlotProps.popper,
      ...slotProps.popper,
      sx: {
        ...baseSlotProps.popper.sx,
        ...slotProps.popper?.sx,
        '& .MuiTooltip-tooltip': {
          ...baseSlotProps.popper.sx['& .MuiTooltip-tooltip'],
          ...slotProps.popper?.sx?.['& .MuiTooltip-tooltip'],
        },
      }
    }
  } : baseSlotProps

  return (
    <Tooltip
      title={title}
      arrow={arrow}
      followCursor={followCursor}
      enterTouchDelay={enterTouchDelay}
      leaveTouchDelay={leaveTouchDelay}
      leaveDelay={leaveDelay}
      slotProps={mergedSlotProps}
      {...props}
    >
      {children}
    </Tooltip>
  )
}
